import { apiRequest } from '@/common/utils/request.common'
import { normalizeBaseHome } from '@/common/normalize/normalize-base-home'
import { API_BASE_URL, HTTP_METHOD_GET } from '@/common/utils/request.const'
import { HOME_API_ERROR_RESPONSE } from '@/common/resources/home-api-error-response'

/**
 * 리스트 더보기 홈 데이터 catalog api
 * @param uiCode
 * @returns {Promise<{data: undefined|*}>}
 */
export const getViewMoreHomeData = async ({ uiCode = '' }) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL}/v1/viewmore/${uiCode}`,
      method: HTTP_METHOD_GET,
    })

    response.data = normalizeBaseHome(response?.data?.data)

    return response
  } catch (e) {
    console.error(`Get View More Home Data Error ${e.message}`)

    return HOME_API_ERROR_RESPONSE
  }
}
